import { withStyles } from '@material-ui/core';
import React, { PureComponent } from 'react';
import "./DrawMarquee.css";

// 跑马灯
const speed = 10
let marquee_id = 1

const GiftIcon = require("../../../images/icons/gift_icon.png");


class DrawMarquee extends PureComponent {

    constructor(props) {
        super(props)
        this.viewRef = React.createRef()
        this.textRef = React.createRef()
    }

    componentDidMount = async () => {
        try {
            const { start, end, duration } = await this.isNeedToMove()
            this.move(start, end, duration)
        } catch (e) { }
    }

    componentDidUpdate = async (prevProps) => {
        const { text } = this.props
        if (text != prevProps.text) {
            try {
                const { start, end, duration } = await this.isNeedToMove()
                this.move(start, end, duration)
            } catch (e) { }
        }
    }

    isNeedToMove = () => {
        return new Promise((resolve, reject) => {
            const viewWidth = this.viewRef.current.getBoundingClientRect().width
            const textWidth = this.textRef.current.getBoundingClientRect().width
            const minWidth = textWidth < viewWidth ? viewWidth : textWidth;
            const duration = Math.floor(minWidth / speed)
            if (textWidth > viewWidth) {
                const start = viewWidth
                const end = -Math.floor(textWidth)
                return resolve({ start, end, duration })
            } else {
                const start = viewWidth
                const end = -viewWidth
                return resolve({ start, end, duration })
            }
        })
    }

    move(start, end, duration) {
        ++marquee_id
        this.viewRef.current.style = `
            animation: move_${marquee_id} ${duration}s linear infinite;
        `
        var styleSheets = document.styleSheets[0];  //获取样式表引用
        var index = styleSheets.length;  //获取样式表中包含样式的个数
        if (styleSheets.insertRule) {  //判断浏览器是否支持insertRule()方法
            styleSheets.insertRule(`@keyframes move_${marquee_id}
            {
                from {
                    transform: translateX(${start}px);
                }
                to {
                    transform: translateX(${end}px);
                }
            }`, index);
        }
    }
    render() {
        const { text } = this.props
        return (
            <div className="Marquee_Bar">
                <div className="Marquee_View" ref={this.viewRef}>
                    <img src={GiftIcon} className="Marquee_Icon" />
                    <div className="Marquee_Text">{text}</div>
                </div>
                <div className="Marquee_Opacity" ref={this.textRef}>
                    <img src={GiftIcon} className="Marquee_Icon" />
                    <div className="Marquee_Text">{text}</div>
                </div>
            </div>
        );
    }
}

export default withStyles((theme) => ({


}))(DrawMarquee); 